import config from '../config'



class BingAdsAnalytics {

    constructor(){

        if(config.production){

            (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"17559933"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");


        }

    }

    emitCustomEvent({category, action, label, value}){
        window.uetq.push('event', action, {'event_category': category, 'event_label': label, 'event_value': value});
    }

}

export default class BingAdsAnalyticsPlugin {

    static install(Vue, options = {}) {
window.testVue = Vue;
        Vue.$bingAdsAnalytics = new BingAdsAnalytics(options);

        Vue.prototype.$bingAdsAnalytics = Vue.$bingAdsAnalytics;

    }

}
